export default class fvRenderGrid{
    constructor(){

    }
    rend(){

    }
    RenderGrid(canvas, rect, color, Grade) {
        var pot = new Array();
        canvas.beginPath();
        this.grade = Grade;
        var spaceBetween = 8;
        var grid_cols = rect.width/spaceBetween;
        var grid_rows = rect.height/spaceBetween;
        var cell_width = parseFloat(rect.width / grid_cols);
        var cell_height = parseFloat(rect.height / grid_rows);
        var cell = 8;
        canvas.lineWidth = 1;
        canvas.strokeStyle = rect.color;
        switch (this.grade){
            case 0:
                this.landscape(canvas,rect,grid_cols,cell_width);
                break;
            case 1:
                this.vertical(canvas,rect,grid_cols,cell_height);
                break;
            case 2:
                this.rightBias(canvas,rect,cell);
                break;
            case 3:
                this.leftBias(canvas,rect,cell);
                break;
            case 4:
                this.landscape(canvas,rect,grid_cols,cell_width);
                this.vertical(canvas,rect,grid_cols,cell_height);
                break;
            case 5:
                this.leftBias(canvas,rect,cell);
                this.rightBias(canvas,rect,cell);
                break;
            default :
                this.leftBias(canvas,rect,cell);
                this.rightBias(canvas,rect,cell);
                break;
        }
        canvas.stroke();
    }

    //横线
    landscape(canvas,rect,grid_rows,cell_height){
        for(var row = 0; row <= grid_rows; row++){
            var y =  parseFloat(rect.y) + row * cell_height;
            var width = parseFloat(rect.x) + parseFloat(rect.width);
            canvas.moveTo(rect.x,y);
            canvas.lineTo(width,y);
        }
    }

    //竖线
    vertical(canvas,rect,grid_cols,cell_width){
        for (var col = 0; col <= grid_cols; col++) {
            var x = parseFloat(rect.x) + col * cell_width;
            var height = parseFloat(rect.y) + parseFloat(rect.height);
            canvas.moveTo(x,rect.y);
            canvas.lineTo(x,height);
        }
    }

    //左斜线
    leftBias(canvas,rect,grid_cols){
        var grid_length = grid_cols*16;
        for (var col = 0; col <= grid_length; col++) {
            var x = parseFloat(rect.x) + col * grid_cols;
            var y = parseFloat(rect.y) + col * grid_cols;
            canvas.moveTo(rect.x,y);
            canvas.lineTo(x,rect.y);
        }
    }

    //右斜线
    rightBias(canvas,rect,grid_cols){
        var grid_length = grid_cols*16;
        for (var col = 0; col <= grid_length; col++) {
            var x = parseFloat(rect.x) + parseFloat(rect.width) - col * grid_cols;
            var y = parseFloat(rect.y) + col * grid_cols;
            var width = parseFloat(rect.x) + parseFloat(rect.width);
            canvas.moveTo(x,rect.y);
            canvas.lineTo(width,y);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/render/fvRenderGrid.js